<div id="newsContainer">
  <section id="main" class="bg-light">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="page-title" [title]="'news_information' | translator:'base'" [innerHtml]="'news_information' | translator:'base'">News &amp; Information</h1>
          <div *ngIf="previewItemId" class="alert alert-warning" role="alert">
             <h2>Preview Mode</h2>
          </div>
          <div id="newsApp">
            <hr>
            <article *ngFor="let newsItem of translatedArticles; let index = index">
                <h2 class="newsItemContent" [innerHtml]="getTitle(newsItem)"></h2>
                <div [innerHtml]="getBody(newsItem)"></div>
              <hr>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="overlay" *ngIf="!userProfileLoaded">
    <h1 class="heading" [innerHtml]="'Loading' | translator:'base'">Loading</h1>
    <img />
  </div>
</div>
   